import React, { useState, useEffect } from 'react';
import SideBar from '../SideBar/SideBar';
import BalanceWidget from '../../widgets/BalanceWidget/BalanceWidget';
import { Modal, ModalBody } from 'reactstrap';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';
import { useSelector } from 'react-redux';
import { startUpdateDashboardSettings } from '@actions/webmaster';
import DashboardSettings from '../../components/DashboardSettings/DashboardSettings';
import { useDispatch } from 'react-redux';
import { items } from './../../pages/dashboard/itemsDashboard';
import FaqHeaderList from '../../components/Faq/FaqHeaderList';

const HeaderMobile = () => {
  const { balance, unreadTicketsCount, config, tree } = useSelector((state) => ({
    balance: state.webmaster.balance,
    unreadTicketsCount: state.webmaster.unreadTicketsCount,
    config: state.webmaster.dashboardSettings,
    tree: state.faq?.tree || [],
  }));
  const dispatch = useDispatch();
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [isOpenBalance, setIsOpenBalance] = useState(false);
  const [isOpenFaqList, setIsOpenFaqList] = useState(false);
  const isFaqPage = window.location.pathname.startsWith('/faq');
  const isDashboardPage = window.location.pathname === '/dashboard';

  const handleSettingsChange = (settings) => {
    dispatch(startUpdateDashboardSettings(settings));
  };

  useEffect(() => {
    const checkScreenWidth = () => {
      if (window.innerWidth >= 1720) {
        setIsOpenSidebar(false);
      }
    };

    checkScreenWidth();

    window.addEventListener('resize', checkScreenWidth);

    return () => {
      window.removeEventListener('resize', checkScreenWidth);
    };
  }, []);

  const toggleModalSidebar = () => {
    setIsOpenSidebar(!isOpenSidebar);
  };

  const toggleModalBalance = () => {
    setIsOpenBalance(!isOpenBalance);
  };

  const toggleModalFaqList = () => {
    setIsOpenFaqList(!isOpenFaqList);
  };

  return (
    <header className="sidebar-main-header">
      <button onClick={() => setIsOpenSidebar(true)} className="side-main-header-burger">
        {!!unreadTicketsCount && (
          <span className="side-main-header-burger-notification">{unreadTicketsCount}</span>
        )}
      </button>
      <p className="side-main-header-title">
        {document.title === 'Affiliate' ? '' : document.title}
      </p>
      <button onClick={() => setIsOpenBalance(true)} className="side-main-header-balance">
        <SVG
          className="sidebar-link-icon"
          src={`${STATIC_PATH}/img/action-icons/balance.svg`}
          height="16"
          width="15"
          cacheRequests
        />
      </button>
      {isFaqPage && (
        <button onClick={toggleModalFaqList} className="side-main-header-faq">
          <SVG
            className="sidebar-link-icon"
            src={`${STATIC_PATH}/img/action-icons/book-icon.svg`}
            height="16"
            width="16"
            cacheRequests
          />
        </button>
      )}
      {isDashboardPage && (
        <DashboardSettings config={config} items={items} onChange={handleSettingsChange} />
      )}
      <Modal
        isOpen={isOpenSidebar}
        modalClassName="modal-sidebar-main-header"
        backdrop={true}
        toggle={toggleModalSidebar}
      >
        <ModalBody>
          <button className="sidebar-main-header-close" onClick={() => setIsOpenSidebar(false)} />
          <SideBar closeModal={() => setIsOpenSidebar(false)} />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isOpenBalance}
        modalClassName="modal-sidebar-balance"
        backdrop={true}
        toggle={toggleModalBalance}
      >
        <ModalBody>
          <button className="sidebar-main-balance-close" onClick={() => setIsOpenBalance(false)} />
          <BalanceWidget balance={balance} />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isOpenFaqList}
        modalClassName="modal-sidebar-faq"
        backdrop={true}
        toggle={toggleModalFaqList}
      >
        <ModalBody>
          <button className="modal-sidebar-faq-close" onClick={() => setIsOpenFaqList(false)} />
          <div>
            <h3>Содержание</h3>
            <FaqHeaderList
              tree={tree}
              closeModal={() => {
                setIsOpenFaqList(false);
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    </header>
  );
};

export default HeaderMobile;
